import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

const toast = useToast({
    position: 'bottom',
    duration: 10000,
});
export default defineNuxtPlugin(() => {
    return {
        provide: {
            toast,
        }
    }
});